var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('img',{staticClass:"nodata-icon",attrs:{"src":require('@/assets/nodata.png')}}),(_vm.message)?_c('div',{staticClass:"nodata-text",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e(),(_vm.btntext)?_c('van-button',{staticClass:"nodata-btn",on:{"click":_vm.onOk}},[_vm._v(" "+_vm._s(_vm.btntext)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }